export default {
  artistList: document.querySelector('.js-artists'),
  artistModal: document.querySelector('.js-artist-modal'),
};
